import Vue from 'vue';
import store from '@/store';
import ContractProxy from "../../../proxies/ContractProxy";
import * as types from './mutation-types';

/**
 * 계약서 리스트
 * @param commit
 * @param param
 */
export const findAll = ({ commit }, param) => {
  new ContractProxy(param)
    .all()
    .then((response) => {
      commit(types.LIST, response);
    });
};

/**
 * 계약서 삭제
 * @param commit
 * @param param
 */
export const deleteContract = ({ commit }, searchParam) => {
  new ContractProxy()
    .destroy(searchParam.contractSeq)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        store.dispatch('contract/findAll', searchParam);
      } else {
        alert(response.header.resultMessages);
      }
    });
};

export default {
  findAll,
  deleteContract,
};
